import { render } from "./CustomerNoteAttachmentsField.vue?vue&type=template&id=7a7716ad"
import script from "./CustomerNoteAttachmentsField.vue?vue&type=script&lang=js"
export * from "./CustomerNoteAttachmentsField.vue?vue&type=script&lang=js"

import "../styles/CustomerNoteAttachmentsField.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__